import {
  createSlice,
  createAsyncThunk,
  // PayloadAction,
  // ActionReducerMapBuilder,
} from "@reduxjs/toolkit";
import { config } from "../../../utils/config";
import { tokenDecode } from "../../../utils/helper";
import axios from "axios";

const decoded = tokenDecode();
const { data } = decoded;
// const seller_id = data?.user?.seller_id;
const { apiEndpoint } = config;
// const accessToken = localStorage.getItem("us_st_d");

interface BookingState {
  loader: boolean;
  RoomData: any;
  error: string | null;
}

const initialState: BookingState = {
  loader: false,
  RoomData: null,
  error: null,
};

// Create the async thunk for fetching vendor data
export const getBookingRoom = createAsyncThunk(
  "RoomBooking/getBookingRoom",
  async (
    { sellerId, day, len }: { sellerId: string; day: string; len: number },
    { rejectWithValue },
  ) => {
    try {
      const payload = { day, sellerId, len };
      const response = await axios.post(
        `${apiEndpoint}/bookings/getsevendays`,
        payload,
      );
      if (response.data?.success === true) {
        return response.data?.data;
      } else {
        return rejectWithValue("Failed to fetch room booking data");
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  },
);

// Create the slice
const RoomBookingSlice = createSlice({
  name: "RoomBooking",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getBookingRoom.pending, (state) => {
      state.loader = true;
      state.error = null;
      state.RoomData = null;
    });
    builder.addCase(getBookingRoom.fulfilled, (state, action) => {
      state.loader = false;
      state.RoomData = action.payload;
      state.error = null;
    });
    builder.addCase(getBookingRoom.rejected, (state, action) => {
      state.loader = false;
      state.RoomData = null;
      state.error = action.payload as string;
    });
  },
});

export default RoomBookingSlice.reducer;
